import useUser from "@saleor/hooks/useUser";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";

export interface SaleUser {
  id: string;
  isKAMS: boolean;
  isSuperUser: boolean;
}

export default function useSaleUserType(): SaleUser {
  const user = useUser();

  return {
    id: user.userDetail.id,
    isKAMS:
      user.userDetail.accessGroup !== null &&
      user.userDetail.accessGroup.smopUsertypeCode ===
        SmopUserTypeCode.ACCOUNT_MANAGER,
    isSuperUser: user.userDetail.accessGroup === null
  };
}
